$(function() {
    var resizeTimer = false;
    var windowWidth = $(window).width();

    $(window).on('resize', function() {
        var newWindowWidth = $(window).width();
        
        if (windowWidth !== newWindowWidth) {
            clearTimeout(window.resizedFinished);
            
            window.resizedFinished = setTimeout(function() {
                $(window).trigger($.Event('widthResizeEnd')); 
            }, 250);
        }
        
        windowWidth = newWindowWidth;
    });
});